<template>
  <div class="pannel">
    <div v-if="!show">
      <div class="watting-dot"></div>
    </div>
    <div v-if="show">
      <!-- 滚动面板 -->
      <div class="row flex" v-if="notice !== '' && notice_show">
        <span
          class="iconfont icon-gonggao m-r-10"
          style="font-size: 20px"
        ></span>
        <notice-component-vue
          class="flex-1"
          :show="true"
          :content="notice"
          @handleClose="handleClose"
        />
      </div>
      <div class="row">
        <div class="pannel_content">
          <div class="myOrder1">
            <div class="block_title">{{ $t("pannel.my_subscription") }}</div>
          </div>
          <!-- 没有订阅 -->
          <div
            class="myOrder2"
            style="height: 95px; cursor: pointer"
            @click="jumpOredr()"
            v-if="hasSubscribe === false"
          >
            <div class="center_content">
              <img
                style="width: 29px; height: 29px"
                src="../../assets/img/add.png"
              />
            </div>
            <div
              class="center_content"
              style="padding-top: 0.5rem; padding-bottom: 1rem"
            >
              <span
                style="
                  color: #6c757d;
                  font-size: 14px;
                  letter-spacing: 0.0625rem;
                "
                >{{ $t("aside.purchase_subscription") }}</span
              >
            </div>
          </div>
          <!-- 有订阅 -->
          <div v-else>
            <div style="background-color: #fff">
              <div class="subscribe">
                <div class="subscribe_information">
                  <div class="title1">
                    {{ subscribe.name }}
                  </div>
                  <div class="title2">
                    {{ $t("pannel.expires_on") }}&nbsp;{{
                      changeTime(subscribe.expiration)
                    }}, {{ $t("pannel.expiration") }}&nbsp;{{ subscribe.date }}.
                  </div>
                  <div><el-progress :percentage="subscribe.percentage" /></div>
                  <div class="title3">
                    {{ $t("pannel.used") }}
                    {{ subscribe.used }} / {{ $t("pannel.total") }}
                    {{ subscribe.total }}
                  </div>
                </div>
              </div>
            </div>
            <div style="background-color: #fff">
              <div
                class="subscribe"
                v-for="(su, index) in notStarted"
                :key="index"
              >
                <el-divider class="m-0"></el-divider>
                <div class="subscribe_information">
                  <div class="title1">
                    {{ su.pdName }}
                  </div>
                  <div class="title2">
                    {{ $t("subscription.other_subscripe") }}&nbsp;{{
                      changeTime(su.startAt)
                    }}.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-warp">
        <div class="pannel_content">
          <div class="myOrder1">
            <div class="block_title">{{ $t("pannel.shortcut") }}</div>
          </div>
          <div class="myOrder2">
            <div class="v2board-shortcuts-item" @click="jumpToDocument()">
              <div>
                <div class="item1" @click="jumpToDocument()">
                  {{ $t("pannel.view_tutorial") }}
                </div>
                <div class="item2">{{ $t("pannel.learn") }}</div>
              </div>
              <div class="item3">
                <img
                  style="height: 30px; width: 30px"
                  src="../../assets/img/help_document.png"
                />
              </div>
            </div>
            <div class="v2board-shortcuts-item" @click="quick()">
              <div>
                <div class="item1">{{ $t("pannel.quick_subscription") }}</div>
                <div class="item2">{{ $t("pannel.quick_import") }}</div>
              </div>
              <div class="item3">
                <img
                  style="height: 30px; width: 30px"
                  src="../../assets/img/subscribe.png"
                />
              </div>
            </div>
            <div class="v2board-shortcuts-item" @click="jumpOredr()">
              <div>
                <div class="item1">{{ $t("pannel.renew_subscription") }}</div>
                <div class="item2">
                  {{ $t("pannel.renew_your_current_subscription") }}
                </div>
              </div>
              <div class="item3">
                <img
                  style="height: 30px; width: 30px"
                  src="../../assets/img/black_bag.png"
                />
              </div>
            </div>
            <div class="v2board-shortcuts-item">
              <div>
                <div class="item1">{{ $t("pannel.encounter_problems") }}</div>
                <div class="item2">{{ $t("pannel.communicate") }}</div>
              </div>
              <div class="item3">
                <img
                  style="height: 30px; width: 30px"
                  src="../../assets/img/black_help.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-dialog v-model="visible">
          <div style="white-space: pre-wrap">{{ notice }}</div>
        </el-dialog>
      </div>
      <div>
        <el-dialog
          v-model="orderVisible"
          style="width: auto"
          class="previewDialog"
          align-center
        >
          <div>
            <div class="order_visible_item" @click="getLink()">
              <div class="order_visible_item_img">
                <img
                  style="height: 25px; height: 25px"
                  src="../../assets/img//other/copy.png"
                />
              </div>
              <div class="order_visible_item_title">
                {{ $t("pannel.copy") }}
              </div>
            </div>
            <el-divider class="divider" />
            <div class="order_visible_item" @click="showQrCode()">
              <div class="order_visible_item_img">
                <img
                  style="height: 25px; height: 25px"
                  src="../../assets/img/other/QR.png"
                />
              </div>
              <div class="order_visible_item_title">
                {{ $t("pannel.qr") }}
              </div>
            </div>
            <el-divider class="divider" />
            <div class="order_visible_item_but">
              <el-button
                type="primary"
                style="width: 100%"
                @click="jumpToDocument()"
              >
                {{ $t("pannel.usage") }}</el-button
              >
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 二维码弹窗 -->
      <div>
        <el-dialog
          v-model="isShowQrCode"
          style="width: 150px"
          class="previewDialog"
          align-center
        >
          <el-row type="flex" justify="center">
            <canvas ref="myCanvas" />
          </el-row>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackages, subscribeApi, getAllNotice } from "../../utils/api";
import { countDays, timeFilter } from "../../utils/tool";
import { ElNotification } from "element-plus";
import clipboard3 from "vue-clipboard3";
import QrCode from "qrcode";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import NoticeComponentVue from "../utils/NoticeComponent.vue";
import { receive_app } from "../../utils/lang_change";
export default {
  components: { NoticeComponentVue },
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();
    let changelanguage = (lang) => {
      locale.value = receive_app(lang);
      sessionStorage.setItem("lang", receive_app(lang));
    };
    return { t, store, changelanguage };
  },
  data() {
    return {
      notice: "",
      notice_show: true,
      visible: false, //公告弹窗
      orderVisible: false, //订单弹窗
      subscribe: {
        name: "",
        expiration: "",
        date: "",
        total: 0,
        used: 0,
        link: "",
        percentage: 0,
        resetDay: 0,
      }, //用户正在使用的订阅信息
      allSubscribes: [], //用户所有的订阅信息
      notStarted: [], //未开始的订阅信息
      hasSubscribe: false,
      show: false,
      isShowQrCode: false, //二维码弹窗
    };
  },
  methods: {
    handleClose() {
      this.notice_show = false;
    },
    close() {
      this.visible = false;
    },
    clickNotice() {
      this.visible = true;
    },
    jumpOredr() {
      this.store.commit("updateActiveName", "aside.purchase_subscription");
      this.store.commit("updateActivePath", "/shop");
      this.$router.push("/shop");
    },
    //一键订阅
    quick() {
      this.orderVisible = true;
    },
    //获取订阅链接
    getSubscribe() {
      return new Promise((resolve, reject) => {
        subscribeApi()
          .then((res) => {
            if (res !== undefined && res.data !== null) {
              this.subscribe.link = res.data;
              resolve("success");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getLink() {
      if (this.subscribe.link === "") {
        await this.getSubscribe();
      }
      const { toClipboard } = clipboard3();
      await toClipboard(this.subscribe.link);
      this.orderVisible = false;
      return ElNotification({
        title: "",
        message: "success",
        type: "success",
      });
    },
    // 显示二维码
    async showQrCode() {
      if (this.subscribe.link === "") {
        await this.getSubscribe();
      }
      let string = this.subscribe.link;
      //显示弹窗
      this.isShowQrCode = true;
      this.$nextTick(() => {
        QrCode.toCanvas(this.$refs.myCanvas, string);
      });
    },
    //跳转到教程
    jumpToDocument() {
      this.store.commit("updateActiveName", "aside.knowledge_base");
      this.store.commit("updateActivePath", "/document");
      this.$router.push("/document");
    },
    //获取订阅的套餐
    getPackage() {
      getPackages().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            this.allSubscribes = res.data.data;
            if (this.allSubscribes.length !== 0) {
              let data = this.allSubscribes[0];
              this.hasSubscribe = true;
              let day = countDays(data.endAt);
              this.subscribe = {
                name: data.pdName,
                expiration: data.endAt,
                date: day,
                total: data.trafficTotal,
                used: data.trafficUsed,
                percentage: data.trafficUsedPct - 0,
                link: "",
              };
            }
            this.notStarted = this.allSubscribes.filter((_, index) => {
              return index !== 0;
            });
          } else {
            return ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
        }
      });
    },
    //转换
    changeTime(time) {
      return timeFilter(time);
    },
    //获取公告
    getNotices() {
      getAllNotice().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            if (res.data.data) {
              const {content} = res.data.data
              if (content !== null && content !== "") {
                this.notice = content;
              }
            }
          } else {
            return ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
        }
      });
    },
  },
  async created() {
    let lang = this.$route.query.lang;
    if (lang !== null && lang !== undefined) {
      this.changelanguage(lang);
    }
    this.getNotices();
    this.getPackage();
    this.show = true;
  },
  watch: {
    "$i18n.locale"() {
      this.notice = "";
      this.getNotices();
      this.getPackage();
    },
  },
};
</script>

<style>
.previewDialog.el-dialog > .el-dialog__header {
  display: none;
}

.previewDialog.el-dialog > .dj-dialog-content {
  padding: 0;
  overflow: unset;
}

.previewDialog.el-dialog > .el-dialog__body {
  padding: 0px;
}
</style>

<style scoped lang="less">
.divider {
  margin: 0px;
}

.subscribe {
  border-radius: 0.2rem;
  overflow-x: visible;
  padding: 0.25rem;
  transition: opacity 0.25s ease-out;
}

.subscribe_button {
  display: flex;
  justify-content: space-between;
}

.subscribe_button_1 {
  background-color: #409eff;
  border: 1px solid #409eff;
  border-radius: 20px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  margin: 4px 4px 4px 0px;
  padding: 4px 16px;
  cursor: pointer;
}

.subscribe_button_2 {
  border: 1px solid transparent;
  border-radius: 20px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: 4px 4px 4px 0px;
  padding: 4px 16px;
  color: #409eff;
  cursor: pointer;
}

.title1 {
  font-size: 20px;
  font-weight: 600;
  color: #171717;
  margin: 0px 0px 4px;
}

.title2 {
  margin: 0px 0px 20px;
  color: #6c757d;
  font-size: 14px;
}

.title3 {
  margin: 0px 0px 16px;
  color: #495057;
  font-size: 14px;
}

.subscribe_information {
  padding: 16px;
}

.order_visible_item {
  min-width: 260px;
  height: 37.5px;
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}

.order_visible_item_img {
  width: 65px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.order_visible_item_title {
  padding: 8px 0px 0px;
  flex: 1;
  font-size: 14px;
  color: #000000a6;
}

.order_visible_item_but {
  height: 40px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.my-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notice {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/deep/.el-carousel__container {
  height: 100%;
}

.demonstration {
  color: black;
}

.el-carousel__item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  display: inline-block;
  overflow: hidden;
  padding: 1.25rem;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.pannel {
  height: 100%;
  width: 100%;
  max-width: 1200px;
  max-height: 100%;
}

.pannel_content {
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
  box-shadow: 0 1px 3px rgba(228, 228, 228, 0.5),
    0 1px 2px rgba(228, 228, 228, 0.5);
  background-color: #fff;
}

.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // margin-right: -14px;
  // margin-left: -14px;
  // width: 100%;
  // padding: 0 14px;
  margin-bottom: 1.5rem;
}

.myOrder1 {
  background-color: #fafafa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  transition: opacity 0.25s ease-out;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
}

.myOrder2 {
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  transition: opacity 0.25s ease-out;
  margin: 0 auto;
  // padding: 1.25rem 1.25rem 1px;
  overflow-x: visible;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.block_title {
  flex: 1 1 auto;
  min-height: 1.75rem;
  margin: 0;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.75;
}

.center_content {
  display: flex;
  justify-content: center;
}

.v2board-shortcuts-item {
  cursor: pointer;
  padding: 20px;
  border-bottom: 1px solid #eee;
  height: 39px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item1 {
  font-size: 14px;
}

.item2 {
  font-size: 12px;
  opacity: 0.5;
}

.item3 {
  font-size: 30px;
  right: 20px;
  opacity: 0.5;
  font-family: simple-line-icons;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}
</style>